import request from '@/utils/request'

export function login(username, userpwd) {
  let param = new URLSearchParams()
  param.append('username', username)
  param.append('userpwd', userpwd)
  return request({
    url: '/manager/login',
    method: 'post',
    data: param
    /*
    data: {
      username,
      userpwd
    }
    */
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/manager/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js